export const FOMR_INPUT_REGISTER = ({
  channelBuyList,
  channelBuyType,
  mobileBrandOptions,
  mobileModelOptions,
  selectedProduct,
  storeTypeCodeList,
}) => {
  const span = 24;
  const SCAN_QR = [
    {
      name: 'storeId',
      label: 'สาขา',
      type: 'DROPDOWN',
      properties: {
        options: storeTypeCodeList || [],
      },
      rules: {
        required: true,
      },
      span,
    },
  ];
  return [
    {
      name: 'warrantyNumberCode',
      label: 'รหัสรับประกัน',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล (Name - Surname)',
      type: 'INPUT',
      rules: {
        required: true,
      },
      span,
    },
    {
      name: 'telephone',
      label: 'หมายเลขโทรศัพท์มือถือ (Mobile phone)',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'channelBuyId',
      label: 'ซื้อผ่านช่องทาง (Purchase channel)',
      type: 'DROPDOWN',
      properties: {
        options: channelBuyList || [],
      },
      rules: {
        required: true,
      },
      span,
      disabled: !!selectedProduct,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    ...(channelBuyType === 'COM7' ? SCAN_QR : []),
    {
      name: 'mobileBrandId',
      label: 'ยี่ห้อโทรศัพท์ (Mobile phone brand)',
      type: 'DROPDOWN',
      properties: {
        options: mobileBrandOptions || [],
      },
      rules: {
        required: true,
      },
      span,
      disabled: !!selectedProduct,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    {
      name: 'mobileModelId',
      label: 'รุ่นโทรศัพท์ (Mobile phone model)',
      type: 'DROPDOWN',
      properties: {
        options: mobileModelOptions || [],
      },
      rules: {
        required: true,
      },
      disabled: !!selectedProduct,
      span,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    {
      name: 'text',
      type: 'LABEL',
      span,
    },
  ];
};

export const FORM_UPLOAD_PACKAGE = () => {
  const span = 24;
  return [
    {
      name: 'packageImage',
      label: 'แนปภาพสินค้าคู่ใบเสร็จ',
      type: 'UPLOAD_HORIZONTAL', // เปลี่ยนเป็น type ใหม่
      rules: {
        required: true,
        message: 'กรุณาอัพโหลดรูปภาพสินค้าคู่ใบเสร็จ',
      },
      maxCount: 1,
      listType: 'picture-card',
      span,
    },
  ];
};
